import { Youtube, Tiktok, Note, RakutenRoom, XIcon, GoogleMap, Instagram } from '@travel/icons/ui';

export const getSNSIcons = (size = 24) => {
  return {
    INSTAGRAM: <Instagram size={size} />,
    TIKTOK: <Tiktok size={size} />,
    X: <XIcon size={size} />,
    YOUTUBE: <Youtube size={size} />,
    GOOGLE_MAP: <GoogleMap size={size} />,
    NOTE: <Note size={size} />,
    ROOM: <RakutenRoom size={size} />,
  };
};
